import { connect } from 'react-redux'

import {
  closeModal,
  dismissModalMessage,
  showModalMessage
} from '../../../../common/actions/layout'
import { createCollection } from '../../../../common/actions/user/collection'
import {
  deleteBookmark,
  addBookmark
} from '../../../../common/actions/user/bookmark'
import { getUserCollections } from '../../../../common/selectors/user'
import AddItemToCollection from './addItemToCollection'

const mapStateToProps = state => {
  const { layout: { modalMessages } } = state

  return {
    collections: getUserCollections(state),
    modalMessages
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => dispatch(closeModal()),
    dismissModalMessage: () => dispatch(dismissModalMessage()),
    deleteBookmark: (collectionID, itemID, id) =>
      dispatch(deleteBookmark(collectionID, itemID, id)),
    addBookmark: (collectionId, itemId) =>
      dispatch(addBookmark(collectionId, itemId)),
    createCollection: payload => dispatch(createCollection(payload)),
    showModalMessage: message => dispatch(showModalMessage(message))
  }
}

const AddItemToCollectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddItemToCollection)

export default AddItemToCollectionContainer



// WEBPACK FOOTER //
// ./client/components/modals/collection/addItemToCollectionContainer.js